(() => {
  'use strict';
  const get = id => document.getElementById(id);
  const dialog = get('zoomDialog'), stage = get('zoomStage'), image = get('zoomImage');
  const pointers = new Map();
  const canonicalText = node => window.OccasioI18n?.originalContent(node) || node?.textContent || '';
  const canonicalAlt = node => window.OccasioI18n?.originalAttribute(node,'alt') || node?.alt || '';
  let entries = [], index = 0, scale = 1, x = 0, y = 0, width = 0, height = 0;
  let gesture = null, drag = null, moved = false, multiTouch = false, returnFocus = null, oldOverflow = '';
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  function paint() {
    const boundsX = Math.max(0, (width * scale - stage.clientWidth) / 2);
    const boundsY = Math.max(0, (height * scale - stage.clientHeight) / 2);
    x = clamp(x, -boundsX, boundsX); y = clamp(y, -boundsY, boundsY);
    image.style.transform = `translate(calc(-50% + ${x}px), calc(-50% + ${y}px)) scale(${scale})`;
    stage.classList.toggle('is-enlarged', scale > 1.01);
    get('zoomLevel').textContent = `${Math.round(scale * 100)}%`;
    get('zoomOut').disabled = scale <= 1; get('zoomIn').disabled = scale >= 4;
    get('zoomFit').disabled = scale <= 1;
  }
  function measure() {
    if (!image.naturalWidth || !stage.clientWidth) return;
    const fit = Math.min(1, stage.clientWidth / image.naturalWidth, stage.clientHeight / image.naturalHeight);
    width = image.naturalWidth * fit; height = image.naturalHeight * fit;
    image.style.width = `${width}px`; image.style.height = `${height}px`; paint();
  }
  function localPoint(clientX, clientY) {
    const rect = stage.getBoundingClientRect();
    return {x: clientX - rect.left - rect.width / 2, y: clientY - rect.top - rect.height / 2};
  }
  function magnify(next, point = {x: 0, y: 0}) {
    if (!image.naturalWidth) return;
    next = clamp(next, 1, 4);
    const ratio = next / scale;
    x = point.x - (point.x - x) * ratio; y = point.y - (point.y - y) * ratio;
    scale = next; paint();
  }
  function fit() { scale = 1; x = y = 0; paint(); }
  function showPhoto(next) {
    index = (next + entries.length) % entries.length;
    const entry = entries[index];
    pointers.clear(); gesture = drag = null; multiTouch = moved = false;
    fit(); image.style.visibility = 'hidden';
    get('zoomCaption').textContent = entry.caption || entry.alt || 'Occasio';
    get('zoomPosition').textContent = `${index + 1} / ${entries.length}`;
    get('zoomPrevious').hidden = get('zoomNext').hidden = get('zoomPosition').hidden = entries.length < 2;
    get('zoomStatus').textContent = window.OccasioTheme.strings.loading; stage.setAttribute('aria-busy', 'true');
    image.alt = entry.alt; image.src = entry.src;
    if (image.complete && image.naturalWidth) ready();
  }
  function ready() {
    if (!dialog.open) return;
    measure(); image.style.visibility = 'visible';
    get('zoomStatus').textContent = ''; stage.setAttribute('aria-busy', 'false');
  }
  function open(source, trigger) {
    if (!source || dialog.open) return;
    const gallery = [...(get('galleryThumbs')?.querySelectorAll('button') || [])].map(button => {
      const photo = button.querySelector('img');
      return {src: photo.src, alt: `${canonicalText(get('productTitle'))} ${canonicalText(get('selectedColor'))} · ${(window.OccasioI18n?.originalAttribute(button,'aria-label') || button.getAttribute('aria-label'))}`, caption: `${canonicalText(get('productTitle'))} ${canonicalText(get('selectedColor'))} · ${(window.OccasioI18n?.originalAttribute(button,'aria-label') || button.getAttribute('aria-label'))}`};
    });
    const current = gallery.findIndex(photo => photo.src === source.src);
    entries = source.closest('#productView') && current >= 0 ? gallery : [{src: source.currentSrc || source.src, alt: canonicalAlt(source), caption: canonicalText(source.closest('figure')?.querySelector('figcaption')) || canonicalAlt(source)}];
    returnFocus = trigger || document.activeElement;
    oldOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
    dialog.showModal(); showPhoto(current >= 0 && entries === gallery ? current : 0); get('closeZoom').focus();
  }
  function close() { if (dialog.open) dialog.close(); }
  function cleanup() {
    document.body.style.overflow = oldOverflow;
    pointers.clear(); gesture = drag = null; stage.classList.remove('is-dragging');
    returnFocus?.focus({preventScroll: true}); returnFocus = null;
  }
  image.addEventListener('load', ready);
  image.addEventListener('error', () => { get('zoomStatus').textContent = 'La fotografia non è disponibile. Prova un’altra vista.'; stage.setAttribute('aria-busy', 'false'); });
  image.addEventListener('dragstart', event => event.preventDefault());
  get('closeZoom').addEventListener('click', close);
  dialog.addEventListener('close', cleanup);
  get('zoomIn').addEventListener('click', () => magnify(scale * 1.5));
  get('zoomOut').addEventListener('click', () => magnify(scale / 1.5));
  get('zoomFit').addEventListener('click', fit);
  get('zoomPrevious').addEventListener('click', () => showPhoto(index - 1));
  get('zoomNext').addEventListener('click', () => showPhoto(index + 1));
  stage.addEventListener('wheel', event => {
    event.preventDefault(); magnify(scale * Math.exp(-clamp(event.deltaY, -120, 120) * 0.004), localPoint(event.clientX, event.clientY));
  }, {passive: false});
  function beginGesture() {
    const values = [...pointers.values()];
    if (values.length >= 2) {
      const [a, b] = values, mid = localPoint((a.x + b.x) / 2, (a.y + b.y) / 2);
      gesture = {distance: Math.max(1, Math.hypot(a.x - b.x, a.y - b.y)), scale, anchorX: (mid.x - x) / scale, anchorY: (mid.y - y) / scale};
      multiTouch = true; drag = null;
    } else if (values.length === 1) drag = {pointerX: values[0].x, pointerY: values[0].y, x, y};
  }
  stage.addEventListener('pointerdown', event => {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    event.preventDefault(); stage.focus(); stage.setPointerCapture(event.pointerId);
    if (!pointers.size) { moved = false; multiTouch = false; }
    pointers.set(event.pointerId, {x: event.clientX, y: event.clientY}); beginGesture();
  });
  stage.addEventListener('pointermove', event => {
    if (!pointers.has(event.pointerId)) return;
    pointers.set(event.pointerId, {x: event.clientX, y: event.clientY});
    if (pointers.size >= 2 && gesture) {
      const [a, b] = [...pointers.values()], mid = localPoint((a.x + b.x) / 2, (a.y + b.y) / 2);
      scale = clamp(gesture.scale * Math.hypot(a.x - b.x, a.y - b.y) / gesture.distance, 1, 4);
      x = mid.x - gesture.anchorX * scale; y = mid.y - gesture.anchorY * scale; moved = true; paint();
    } else if (drag) {
      const dx = event.clientX - drag.pointerX, dy = event.clientY - drag.pointerY;
      if (Math.hypot(dx, dy) > 6) moved = true;
      if (scale > 1) { x = drag.x + dx; y = drag.y + dy; stage.classList.add('is-dragging'); paint(); }
    }
  });
  function endPointer(event) {
    if (!pointers.has(event.pointerId)) return;
    pointers.delete(event.pointerId); stage.classList.remove('is-dragging'); gesture = null;
    if (pointers.size) { beginGesture(); return; }
    const dx = drag ? event.clientX - drag.pointerX : 0, dy = drag ? event.clientY - drag.pointerY : 0;
    if (event.type === 'pointerup' && !multiTouch && scale <= 1.01 && entries.length > 1 && Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.3) showPhoto(index + (dx < 0 ? 1 : -1));
    else if (!moved && !multiTouch && event.type === 'pointerup') magnify(scale > 1 ? 1 : 2, localPoint(event.clientX, event.clientY));
    drag = null;
  }
  ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(name => stage.addEventListener(name, endPointer));
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape') return; // Native dialog closes and restores focus.
    if (event.key === '+' || event.key === '=') magnify(scale * 1.5);
    else if (event.key === '-') magnify(scale / 1.5);
    else if (event.key === '0') fit();
    else if (event.key.startsWith('Arrow')) {
      if (scale <= 1 && entries.length > 1 && ['ArrowLeft', 'ArrowRight'].includes(event.key)) showPhoto(index + (event.key === 'ArrowRight' ? 1 : -1));
      else { if (event.key === 'ArrowLeft') x += 60; if (event.key === 'ArrowRight') x -= 60; if (event.key === 'ArrowUp') y += 60; if (event.key === 'ArrowDown') y -= 60; paint(); }
    } else return;
    event.preventDefault();
  });
  window.addEventListener('resize', () => { if (dialog.open) measure(); });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-photo-zoom],#openZoom');
    if (trigger) { open(trigger.closest('figure')?.querySelector('img'), trigger); return; }
    if (event.target.id === 'productImage') open(event.target, get('openZoom'));
  });
  const icon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 3H3v5M16 3h5v5M3 16v5h5M21 16v5h-5"/></svg>';
  document.querySelectorAll('.hero-picture,.home-feature-picture,.atelier-grid figure,.city-grid figure,.detail-story figure,.editorial-grid figure,.story-layout figure,.size-image').forEach(figure => {
    const source = figure.querySelector('img'); if (!source) return;
    const button = document.createElement('button'); button.type = 'button'; button.className = 'photo-zoom-trigger'; button.dataset.photoZoom = '';
    button.setAttribute('aria-label', `${window.OccasioTheme.strings.zoom} ${source.alt || window.OccasioTheme.strings.photo}`); button.innerHTML = icon; figure.appendChild(button);
  });
})();
